import setFullbanner from './home/1_fullbanner';
import setBannersLinha from './home/home_banner_linha';
import setIconsVertical from './home/icons_vertical';
import setBrandsCarousel from './home/brands_carousel';
import setProductSlider from './home/3_product_slider';
//addImports

import setTopBar from '../components/topBar';
import handleConditionalLazy from '../components/conditionalLazy';

const Home = {
  init: function () {
    setTopBar();
    handleConditionalLazy();

    setFullbanner()
		setBannersLinha();
		setIconsVertical();
		setBrandsCarousel();
		setProductSlider()
		//calls
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Home.init();
});
